import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router"
import Dash from './Pages/Dash';
import Error404 from './Pages/Error404';
import Events from './Pages/Events';
import Booking from './Pages/Booking';
import Users from './Pages/Users';
import Payments from './Pages/Payments';

const RoutesUrls = () => {
    return ( 
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Dash/>}/>
                <Route path='/Events' element={<Events/>}/>
                <Route path='/Booking' element={<Booking/>}/>
                <Route path='/Users' element={<Users/>}/>
                <Route path='/Payments' element={<Payments/>}/>
                <Route path='*' element={<Error404/>}/>
            </Routes>
        </BrowserRouter>
     );
}
 
export default RoutesUrls;